function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M512,424v16c0,4.4-3.6,8-8,8H16c-8.8,0-16-7.2-16-16V72c0-4.4,3.6-8,8-8h16c4.4,0,8,3.6,8,8v344h472 C508.4,416,512,419.6,512,424z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M96.1,164.8L96.1,164.8c0-8.8,7.2-16,16-16h64c8.8,0,16,7.2,16,16v0c0,8.8-7.2,16-16,16h-64 C103.3,180.8,96.1,173.6,96.1,164.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M272.7,371.4L272.7,371.4c-8,3.7-17.5,0.2-21.3-7.7l-89.6-192.1c-3.7-8-0.2-17.5,7.7-21.3l0,0 c8-3.7,17.5-0.2,21.3,7.7l89.6,192.1C284.1,358.2,280.6,367.7,272.7,371.4z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M435.9,164.8L435.9,164.8c0-8.8-7.2-16-16-16h-64c-8.8,0-16,7.2-16,16v0c0,8.8,7.2,16,16,16h64 C428.7,180.8,435.9,173.6,435.9,164.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M259.3,371.4L259.3,371.4c8,3.7,17.5,0.2,21.3-7.7l89.6-192.1c3.7-8,0.2-17.5-7.7-21.3l0,0 c-8-3.7-17.5-0.2-21.3,7.7l-89.6,192.1C247.9,358.2,251.4,367.7,259.3,371.4z"
})));

var SvgIconDepthChart = function SvgIconDepthChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconDepthChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_depth_chart.04aa08a3.svg";
export { ForwardRef as ReactComponent };